import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { PaymentService } from '../payment.service';
import { Payment } from '@ibe/models';
import { SidebarService } from '@ibe/services/ui';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '@ibe/store/index';
import { DEFAULT_LANGUAGE, DEFAULT_MARKET, SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

@Component({
	selector: 'app-payment-method-paypal',
	templateUrl: './payment-method-paypal.indra.component.html',
	styleUrls: ['./payment-method-paypal.component.scss']
})
export class INDRAPaymentMethodPaypalComponent implements OnInit, OnDestroy {
	
	@Input() displayCovidTermsAndCondition: boolean = false;
	
	isAlive = true;
	hasSavedCredentials: boolean = false;
	
	userInfo$: Observable<any> = this.store.select(fromStore.getUserInfo);
	isLoggedIn: boolean = false;

  formIsValid$ = this.paymentService.formIsValid;

	constructor(
		protected _http: HttpClient,
		private paymentService: PaymentService,
		private sidebarService: SidebarService,
		private bfmStorage: INDRABFMDataStorageService,
		private store: Store<fromStore.State>,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
	) { 
		// check if logged-in user has a stored paypal credential
		const paymentMethodResponse = this.bfmStorage.INDRA_getPaymentMethod();
		if (paymentMethodResponse && paymentMethodResponse.data) {
			this.hasSavedCredentials = paymentMethodResponse.data.storedOCPPaypal;
		}
		
		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(values => {
				this.isLoggedIn = (values) ? true : false;
			});
	}

	ngOnInit() {
	}
	
	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_savePaypalInfo(event) {
        this.paymentService.setPaypalCheck(event.target.checked);
	}

	INDRA_acceptTermsAndConditionsChange(event) {
		if (event.target.checked) {
			const paymentInfo: Payment = {
				name: '',
				time: new Date(),
				status: 'pending',
				method: this.paymentService.getSelectedMethod()
			};
			this.paymentService.setPaymentInfo(paymentInfo);
            this.paymentService.setFormIsValid(true);
		} else {
			this.paymentService.setPaymentInfo(null);
			this.paymentService.setFormIsValid(false);
		}
	}
	
	INDRA_handleBookingTicketConditions() {
		this.sidebarService.openSidebar(['booking-ticket-conditions']);
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
		sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
		sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

}
